import type { RouteRecordRaw } from 'vue-router'
import IndustryIndex from '@/views/frontDesk/industry/index.vue'
import IndustryDetail from '@/views/frontDesk/industry/detail.vue'
import IndustryTabel from '@/views/frontDesk/industry/tabel.vue'
import IndustryMemberTabel from '@/views/frontDesk/industry/memberTabel.vue'
import IndustryList from '@/views/frontDesk/industry/list.vue'


// 行业交流
export const IndustryRoute: Array<RouteRecordRaw> = [
  {
    path: 'industryIndex',
    name: 'IndustryIndex',
    meta: {
      title: '行业交流' 
    },
    component: IndustryIndex
  },
  {
    path: 'industryIndex/industryDetail/:id',
    name: 'IndustryDetail',
    meta: {
      title: '会议详情' 
    },
    component: IndustryDetail
  },
  {
    path: 'industryIndex/industryTabel/:id',
    name: 'IndustryTabel',
    meta: {
      title: '非会员会议报名' 
    },
    component: IndustryTabel
  },
  {
    path: 'industryIndex/industryMemberTabel/:id',
    name: 'IndustryMemberTabel',
    meta: {
      title: '会员会议报名' 
    },
    component: IndustryMemberTabel
  },
  {
    path: 'industryIndex/industryList/:id',
    name: 'IndustryList',
    meta: {
      title: '会议列表' 
    },
    component: IndustryList
  }
]

export default IndustryRoute